import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const PinMap_xs = (props) => {
    const width = props.width ? props.width + 'px' : '16px';
    const height = props.height ? props.height + 'px' : '16px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 16 16"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.25 1.97491L9.75 2.88796L11.5995 2.40547C12.8139 2.08868 14 3.00507 14 4.26007V11.4356C14 12.3078 13.4111 13.07 12.5671 13.2902L9.75 14.0251L6.25 13.1121L4.40047 13.5946C3.1861 13.9113 2 12.995 2 11.74V4.56442C2 3.69221 2.58889 2.92999 3.43286 2.70982L6.25 1.97491ZM7 11.7575L9 12.2793V4.24251L7 3.72077V11.7575ZM5.5 3.72077V11.7575L4.02184 12.1431C3.75785 12.212 3.5 12.0128 3.5 11.74V4.56442C3.5 4.37481 3.62802 4.20911 3.81149 4.16125L5.5 3.72077ZM10.5 4.24251V12.2793L12.1885 11.8388C12.372 11.7909 12.5 11.6252 12.5 11.4356V4.26007C12.5 3.98724 12.2422 3.78803 11.9782 3.8569L10.5 4.24251Z"
            />
        </SvgStyled>
    );
};

export default PinMap_xs;
